(() => {
  const ATC_SELECTORS = '[data-add-to-cart], .mix-and-match-add-package-to-cart';
  const LOCK_MS = 8000;

  const css = `
    .cm-atc-locked{opacity:.75!important;pointer-events:none!important}
    .cm-atc-wrap{position:relative;display:block;width:100%}
    .cm-atc-wrap.cm-atc-locked::after{
      content:"";
      position:absolute;top:50%;left:50%;
      width:18px;height:18px;margin:-9px 0 0 -9px;
      border:2px solid currentColor;border-right-color:transparent;
      border-radius:999px;
      animation:cmSpin .7s linear infinite;
      pointer-events:none;
    }
    @keyframes cmSpin{to{transform:rotate(360deg)}}
    .cm-atc-wrap.cm-atc-locked>[data-add-to-cart],
    .cm-atc-wrap.cm-atc-locked>.mix-and-match-add-package-to-cart{
      color:transparent!important;text-shadow:none!important;caret-color:transparent!important;
    }
  `;
  const styleEl = document.createElement('style');
  styleEl.setAttribute('data-cm-atc-spinner', 'true');
  styleEl.appendChild(document.createTextNode(css));
  document.head.appendChild(styleEl);

  let cmLocked = false;

  function ensureWrap(btn){
    if (!btn) return null;
    const existing = btn.closest('.cm-atc-wrap');
    if (existing) return existing;

    const wrap = document.createElement('span');
    wrap.className = 'cm-atc-wrap';
    btn.parentNode.insertBefore(wrap, btn);
    wrap.appendChild(btn);
    return wrap;
  }

  function lockOne(btn){
    const wrap = ensureWrap(btn);
    if (!wrap) return;
    wrap.classList.add('cm-atc-locked');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
  }

  function unlockOne(btn){
    const wrap = btn.closest('.cm-atc-wrap');
    wrap?.classList.remove('cm-atc-locked');
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
  }

  function lockAll(){
    document.querySelectorAll(ATC_SELECTORS).forEach(lockOne);
  }

  function unlockAll(){
    document.querySelectorAll(ATC_SELECTORS).forEach(unlockOne);
    cmLocked = false;
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(ATC_SELECTORS);
    if (!btn) return;

    if (cmLocked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      return;
    }

    cmLocked = true;
    lockAll();

    window.setTimeout(() => {
      if (cmLocked) unlockAll();
    }, LOCK_MS);

  }, true);

  function prewrap(){
    document.querySelectorAll(ATC_SELECTORS).forEach(ensureWrap);
  }
  document.addEventListener('DOMContentLoaded', prewrap);
  document.addEventListener('shopify:section:load', prewrap);
})();
